import React from "react";
import { styled } from "@linaria/react";
import cn from "classnames";
import { color } from "..";
import ButtonIconV2 from "../ButtonIconV2";
import { StarFill } from "../IconV2/react";

const StyledButtonIcon = styled(ButtonIconV2)`
  &.isFavorite {
    color: ${color.phosphorus400};
  }
`;

interface P extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isFavorite: boolean;
}

const FavoriteButtonIcon = ({ isFavorite, ...props }: P) => (
  <StyledButtonIcon
    className={cn({
      isFavorite,
    })}
    {...props}
  >
    <StarFill />
  </StyledButtonIcon>
);

export default FavoriteButtonIcon;
